import React from 'react'
import Image from "next/legacy/image"
import LoadingSvg from '../../atoms/Loading/Loading'

const MyImage = (props) => {
  const width = props.width || 264
  const height = props.height || width
  const placeholder = `https://placehold.co/${width}x${height}/png`

  return props?.className ? (
    <div className={props?.className}>
      {' '}
      <Image
        layout={props?.layout ? props?.layout : 'intrinsic'}
        {...props}
        src={props.src ? props.src : placeholder}
      />
    </div>
  ) : (
    <Image
      layout={props?.layout ? props?.layout : 'intrinsic'}
      {...props}
      src={props.src ? props.src : placeholder}
    />
  )
}

export default MyImage
